import React from 'react'
import { Flex, Grid, Span, Input, Label, Range } from '@fareye/ui'
import { isEmpty, formatMs } from '@fareye/utils'
import { displayTime, formatForCSV } from '../../../utility/function'
import { PopOverDownloadCSV } from './PopOverDownloadCSV'
import { stoppageCSVColumns } from '../../../utility/constants'
import { tripTabsBackground } from '@fareye/configs'
import { useTranslation } from '@fareye/common'
const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    minHeight: '95%',
    padding: '12px',
    overflowY: 'auto'
  }
}
export const Stoppages = ({
  otherData,
  selectedId,
  onSelect,
  stoppages,
  stoppageSlider,
  currStoppageSlider,
  setCurrStoppageSlider
}: any) => {
  const [stoppageValue, setStoppageValue] = React.useState(currStoppageSlider)
  React.useEffect(() => {
    setStoppageValue(currStoppageSlider)
  }, [currStoppageSlider])
  const { t } = useTranslation()

  return (
    <Flex column style={style.tripTabs}>
      <Flex justifyContentSpaceBetween>
        <Span style={{ fontSize: '14px', fontWeight: 600 }}>
          {t('Stoppages')}
        </Span>
        {!isEmpty(stoppages) && (
          <PopOverDownloadCSV
            fileName={'stoppageData'}
            dataCSV={formatForCSV(stoppages, stoppageCSVColumns)}
          />
        )}
      </Flex>
      {!isEmpty(stoppages) && (
        <Range
          formatLabel={(value: any) => formatMs(value)}
          maxValue={stoppageSlider.max}
          minValue={stoppageSlider.min}
          value={stoppageValue}
          onChange={(value: any) => {
            setStoppageValue(value)
          }}
          onChangeComplete={(value: any) => setCurrStoppageSlider(value)}
        />
      )}
      {!isEmpty(stoppages) && (
        <Grid
          gridTemplateColumns={'30px auto 95px 55px'}
          style={{ marginTop: 16 }}
        >
          <Span></Span>
          <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
            {t('Landmark')}
          </Span>
          <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
            {`${t('Start')} & ${t('End Time')}`}
          </Span>
          <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
            {t('Duration')}
          </Span>
        </Grid>
      )}
      {!isEmpty(stoppages) ? (
        stoppages.map((item: any, index: number) => (
          <Grid
            gridTemplateColumns={'30px auto 110px 55px'}
            style={{ marginTop: 16 }}
            key={`stoppage${index}`}
          >
            <Input
              type="radio"
              checked={item.id === selectedId.stoppage}
              onChange={() => {
                onSelect({ stoppage: item.id })
              }}
            />
            <Span
              dangerouslySetInnerHTML={{
                __html:
                  item &&
                  item.startLandmark &&
                  item.startLandmark.split('/').join('<br/>')
              }}
            />
            <Flex column>
              <Span>{displayTime(item.startTimestampUtc)}</Span>
              <Span>{displayTime(item.endTimestampUtc)}</Span>
            </Flex>
            <Span>{formatMs(item.duration * 1000)}</Span>
          </Grid>
        ))
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  )
}
